import { render } from "./TheSideMenu.vue?vue&type=template&id=d6475892&scoped=true&ts=true"
import script from "./TheSideMenu.vue?vue&type=script&lang=ts"
export * from "./TheSideMenu.vue?vue&type=script&lang=ts"

import "./TheSideMenu.vue?vue&type=style&index=0&id=d6475892&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6475892"]])

export default __exports__